import {Injectable} from "@angular/core";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {Location} from "src/app/domain/samples/rssi/location";
import {BatteryVoltage} from "src/app/domain/samples/rssi/battery-voltage";
import {map, Observable} from "rxjs";

export interface RawBatteryVoltage {
  deviceId: string,
  voltage: number,
  instant: string,
  rssiPerGateway: Record<string, number>
}

@Injectable({
  providedIn: 'root'
})
export class RssiApiClient extends MoovementApiClient {

  locations(farmId: string, from: Date, to: Date) {
    return this.httpClient.get<Location[]>(`${this.baseUrl}/api/rssi/location/farm/${farmId}/${from.toISOString()}/${to.toISOString()}`);
  }

  latestBatteryVoltages(deviceIds: string[]): Observable<BatteryVoltage[]> {
    return this.httpClient.post<RawBatteryVoltage[]>(`${this.baseUrl}/api/rssi/batteryVoltage/latest`, deviceIds)
      .pipe(map(rawBatteryVoltages => rawBatteryVoltages.map(rawBatteryVoltage => this.toBatteryVoltage(rawBatteryVoltage))));
  }

  batteryVoltages(deviceIds: string[], from: Date, to: Date): Observable<BatteryVoltage[]> {
    return this.httpClient.post<RawBatteryVoltage[]>(`${this.baseUrl}/api/rssi/batteryVoltage/${from.toISOString()}/${to.toISOString()}`, deviceIds)
      .pipe(map(rawBatteryVoltages => rawBatteryVoltages.map(rawBatteryVoltage => this.toBatteryVoltage(rawBatteryVoltage))));
  }

  private toBatteryVoltage(rawBatteryVoltage: RawBatteryVoltage): BatteryVoltage {
    return {
      deviceId: rawBatteryVoltage.deviceId,
      voltage: rawBatteryVoltage.voltage,
      instant: this.toDate(rawBatteryVoltage.instant),
      rssiPerGateway: rawBatteryVoltage.rssiPerGateway
    }
  }

  private toDate(value: string) {
    return new Date(value);
  }
}
